import { Helmet } from "react-helmet-async";
import { Layout } from "@/components/layout/Layout";
import { HeroCarousel } from "@/components/home/HeroCarousel";
import { SocialProof } from "@/components/home/SocialProof";
import { PackagesPreview } from "@/components/home/PackagesPreview";
import { PackageQuiz } from "@/components/home/PackageQuiz";
import { HowItWorks } from "@/components/home/HowItWorks";
import { FeaturedGalleries } from "@/components/home/FeaturedGalleries";
import { TestimonialsCarousel } from "@/components/home/TestimonialsCarousel";
import { FinalCTA } from "@/components/home/FinalCTA";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Pixie Clicks - Affordable Wedding Photography in NJ, FL & CO</title>
        <meta
          name="description"
          content="Beautiful wedding photography without the luxury price tag. Affordable photo, video & photo booth experiences for real couples. Serving New Jersey, Florida & Colorado."
        />
        <meta property="og:title" content="Pixie Clicks - Affordable Wedding Photography" />
        <meta property="og:description" content="Beautiful wedding photography without the luxury price tag. Serving NJ, FL & CO." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://pixieclicks.com" />
      </Helmet>
      <Layout>
        <HeroCarousel />
        <SocialProof />
        <PackagesPreview />
        <HowItWorks />
        <FeaturedGalleries />
        <TestimonialsCarousel />
        <PackageQuiz />
        <FinalCTA />
      </Layout>
    </>
  );
};

export default Index;
